<template>
  <el-dialog title=""
    :visible.sync="visible"
    class="pay-passowrd-dilog-components"
    :before-close="close"
    width="432px">
      <img class="top-img" src="../../assets/img/dialog/top-img.png" />
      <div class="six-content">
        <div>请输入6位数支付密码</div>
      </div>
      <div class="content-pay-password">
        <payPassword v-model="password" />
      </div>
      <div slot="footer"
         class="dialog-footer_one"
         @click="commit">
        <div>确认</div>
      </div>
  </el-dialog>

</template>

<script>
  import payPassword from "vue-pay-password";
  import "vue-pay-password/dist/vue-pay-password.css";
  import { post } from "../../util/http";
  export default{
    components:{
      payPassword
    },
    data(){
      return {
        visible : false,
        password : ""
      }
    },
    methods: {
      open(){
        this.visible = true;
        this.password = "";
      },
      close(){
        this.visible = false;
        this.password = "";
      },
      check(){
        if(!this.password){
          return false;
        }
        if(this.password.length!=6){
          return false;
        }
        return true;
      },
      commit(){
        if(!this.check()){ return; }
        let data ={
          pay_password : this.password || ""
        };
        post({
          url: "/api/withdraw/verifyWithdrawPass",
          data
        }).then((res)  => {
          this.close();
          if(status==0){
            this.$emit("confirm");
          }else{
            this.$message({
              showClose: true,
              message: '密码错误',
              type: 'warning'
            });
          }
        })
        .catch(err=>{
          console.log("err",err);
          this.close();
          // this.$emit("confirm");
        })
      }

    }
  }
</script>

<style  scoped lang="stylus">
  .pay-passowrd-dilog-components{
    /deep/{
      .el-dialog{
        border : 8px;
        overflow : hidden;
      }
      .el-dialog__header{
        padding-top : 0px;
      }
      .el-dialog__headerbtn{
        z-index : 10;
      }
      .el-dialog__headerbtn .el-dialog__close{
        color : #999999;
        font-size : 24px;
      }
    }
    .top-img{
      overflow : hidden;
      width : 100%;
      height : 160px;
      position : relative;
      top : -5px;
    }
    .six-content{
      padding : 20px;
      padding-bottom : 0px;
      div{
        text-align : center;
        font-size: 16px;
        color: #666666;
        letter-spacing: 0;
        font-weight: 400;
      }
    }
    .content-pay-password{
      height : 80px;
      display : flex;
      justify-content : center;
      align-items : center;
      padding-bottom : 20px;
    }
    .dialog-footer_one>div{
      height: 40px;
      background: #26D99D;
      border-radius: 20px;
    }
  }
</style>
